import React, { memo } from 'react';
import styled from 'styled-components';
import { BATTLES_TAB_CURRENT_INFO_ID } from '../../../constants';

const CollectTabsHeader = memo(({ battlesAssets, activeTab, onClick, isGrandReward = false }) => {
  const isActive = isGrandReward ? 1 : activeTab;
  const backgroundSrc = isGrandReward
    ? battlesAssets.BATTLES_MODAL_COLLECT_INFO_REWARD
    : battlesAssets.BATTLES_MODAL_STREAK_INFO_REWARD;
  const handleClick = isGrandReward ? undefined : onClick;

  return (
    <>
      <BackgroundImage
        id={BATTLES_TAB_CURRENT_INFO_ID}
        src={battlesAssets.BATTLES_MODAL_CURRENT_INFO_REWARD}
        $isActive={!isActive}
        loading="lazy"
        alt=""
      />
      <BackgroundImage src={backgroundSrc} $isActive={!!isActive} loading="lazy" alt="" />
      <Clickable onClick={handleClick} $isClickable={isGrandReward} role="button" />
    </>
  );
});

CollectTabsHeader.displayName = 'CollectTabsHeader';

export default CollectTabsHeader;

const BackgroundImage = styled.img`
  position: absolute;
  width: 100%;
  display: flex;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  will-change: opacity;
`;

const Clickable = styled.div`
  z-index: 10;
  cursor: ${({ $isClickable }) => ($isClickable ? 'default' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 6vh;
  pointer-events: ${({ $isClickable }) => ($isClickable ? 'none' : 'auto')};
`;

